import { Link } from "react-router-dom";

import { useAuth } from "@/auth/useAuth";

function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function AccountMenu() {
  const { session, logout } = useAuth();
  const profile = session?.profile;
  const partnerName = profile?.partner.name ?? "Account";
  const initials = initialsFromName(profile?.full_name || partnerName);

  return (
    <div className="group relative">
      <button
        type="button"
        className="flex cursor-pointer items-center gap-2.5 rounded-xl py-1 pl-1 pr-2.5 transition hover:bg-surface"
        aria-haspopup="menu"
        aria-label={partnerName}
      >
        <span
          aria-hidden
          className="flex size-8 shrink-0 items-center justify-center rounded-full bg-brand-soft text-xs font-semibold text-brand"
        >
          {initials}
        </span>
        <span className="max-w-[11rem] truncate text-sm font-medium text-ink">{partnerName}</span>
      </button>

      <div className="invisible absolute right-0 top-full z-30 min-w-48 pt-1 opacity-0 transition group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
        <div
          role="menu"
          className="rounded-xl border border-line bg-surface-raised py-1 shadow-[0_8px_24px_rgba(14,11,20,0.12)]"
        >
          <Link
            to="/account"
            role="menuitem"
            className="block cursor-pointer px-3.5 py-2 text-sm text-ink transition hover:bg-brand-soft hover:text-brand"
          >
            Change password
          </Link>
          <button
            type="button"
            role="menuitem"
            className="block w-full cursor-pointer px-3.5 py-2 text-left text-sm text-ink transition hover:bg-brand-soft hover:text-brand"
            onClick={logout}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
